import React, { createContext, useContext } from 'react';
import { useListItem } from '@floating-ui/react';

type TMenuContext = {
  getItemProps: (userProps?: React.HTMLProps<HTMLElement>) => Record<string, unknown>;
  close: () => void;
};

export const MenuContext = createContext<TMenuContext | null>(null);

export const useMenuItem = () => {
  const menu = useContext(MenuContext);
  const { ref } = useListItem();

  if (!menu) return null;

  return { ref, getItemProps: menu.getItemProps, close: menu.close };
};
